import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';
import { IUpdateParties } from '../../../../../../API/order/OrderUpdateAPI';
import { ePartyPurpose } from '../../../../../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../../../../../ui-toolkit/enums/ePartyType';
import { IPropertyAddress } from '../../../../../../ui-toolkit/orders/interfaces/IPropertyAddress';
import { IPartySignatory } from '../../../../../../ui-toolkit/orders/interfaces/IPartySignatory';

// for some reason, the purpose cannot be a Buyer.
const getPurpose = (party: IParty): Exclude<ePartyPurpose, ePartyPurpose.buyer> => {
  if (party.purpose === ePartyPurpose.buyer) {
    return ePartyPurpose.borrower;
  }
  return party.purpose;
};

const getAddress = (party: IParty | IPartySignatory): IPropertyAddress | undefined => {
  if (party.address?.street_address && party.address?.city && party.address?.state && party.address?.zip_code) {
    return party.address;
  }
  return undefined;
};

const getSignatories = (party: IParty): IPartySignatory[] | undefined => {
  if (party.type === ePartyType.person) {
    return undefined;
  }
  return party.signatories.map((signatory) => ({ ...signatory, address: getAddress(signatory) }));
};

// applies the modified purpose and address to the original party.
// if the party is an entity, apply the modified signatories to the party
const getAmendedParty = (
  party: IParty,
  purpose: Exclude<ePartyPurpose, ePartyPurpose.buyer>,
  address?: IPropertyAddress,
  signatories?: IPartySignatory[]
): IParty => {
  if (party.type === ePartyType.person) {
    return { ...party, purpose, address };
  }
  return { ...party, purpose, address, signatories: signatories ?? [] };
};

export const convertToIUpdatePartiesForDeletion = (party: IParty): IUpdateParties => {
  const purpose = getPurpose(party);
  const address = getAddress(party);
  const signatories = getSignatories(party);

  const amendedParty: IParty = getAmendedParty(party, purpose, address, signatories);
  const deleteParties: IParty[] = [amendedParty];

  return { updateParties: [], createParties: [], deleteParties };
};
